import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import '../../public/css/media/_modal-advisory.scss';
import DamagedBanner from './DamagedBanner';

const airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
const seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';

export default class DamagedModal extends Component {
  render() {
    return (
      <Modal className="alert-modal-checkout" show={this.props.isOpen} onHide={this.props.handleClose} autoFocus={true}>
          <Modal.Header closeButton/>
          <Modal.Body>
            <p style={{fontSize: '20px', fontWeight: 600}}>Packages with damaged items</p>
            <DamagedBanner message="All items within package/s listed below are not covered by SC Protect."/>
            <div style={{marginTop: '20px'}}>
              {this.props.damageItems && this.props.damageItems.air && <div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <div style={{ marginRight: 10 }}>
                    <img src={airIcon} alt='air' style={{width: '24px', height: '24px'}} />
                  </div>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>Air Cargo</div>
                  </div>
                </div>
                {this.props.damageItems.air &&
                  this.props.damageItems.air.map(item => 
                    <div style={{fontSize: '16px',
                      fontWeight: 600,
                      padding: '5px 0px',
                      color: '#636363'}}>
                      {item}
                    </div>)
                }
              </div>}
              {this.props.damageItems && this.props.damageItems.air && this.props.damageItems.sea && (
                <hr style={{ margin: '10px 0px' }} />
              )}
              {this.props.damageItems && this.props.damageItems.sea && <div>
                <div style={{display: 'flex', alignItems: 'center' }}>
                  <div style={{ marginRight: 10 }}>
                    <img src={seaIcon} alt='sea' style={{width: '24px', height: '24px'}} />
                  </div>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>Sea Cargo</div>
                  </div>
                </div>
                {this.props.damageItems.sea &&
                  this.props.damageItems.sea.map(item => 
                    <div style={{fontSize: '16px',
                      fontWeight: 600,
                      padding: '5px 0px',
                      color: '#636363'}}>
                      {item}
                    </div>)
                }
              </div>}
            </div>
          </Modal.Body>
          <Modal.Footer>

          </Modal.Footer>
      </Modal>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/DamagedModal.js
 **/